import React, { useEffect } from 'react'
import { Routes, Route, useLocation } from 'react-router-dom'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import ScrollToTop from './components/ScrollToTop'
import FloatingCTA from './components/FloatingCTA'
import Home from './pages/Home'
import About from './pages/About'
import Services from './pages/Services'
import Youth from './pages/Youth'
import Involved from './pages/Involved'
import Contact from './pages/Contact'
import News from './pages/News'
import NotFound from './pages/NotFound'
import Forbidden from './pages/Forbidden'

// Rute titler og beskrivelser iht. SEO krav
const ROUTE_META = {
  '/': {
    title: 'Unges Fremtid',
    description: 'Unges Fremtid er en nonprofitorganisation, der arbejder for at hjælpe og styrke udsatte børn og unge til at få et meningsfyldt liv med stærke relationer i sunde fællesskaber, samt uddannelse og job.'
  },
  '/om-unges-fremtid': {
    title: 'Om Unges Fremtid - Unges Fremtid',
    description: 'Læs om Unges Fremtids formål, værdier og vision om at skabe tryghed, nærvær og håb for udsatte børn og unge.'
  },
  '/vores-arbejde': {
    title: 'Vores arbejde - Unges Fremtid',
    description: 'Se hvordan Unges Fremtid styrker unges trivsel, relationer, skolegang, uddannelse og vej til arbejdsmarkedet.'
  },
  '/for-boern-og-unge': {
    title: 'For børn og unge - Unges Fremtid',
    description: 'Til dig som er ung: Få en tryg voksen at snakke med, hjælp til skole, fritidsjob og et hyggeligt fællesskab uden pres.'
  },
  '/bliv-involveret': {
    title: 'Bliv involveret - Unges Fremtid',
    description: 'Samarbejde for lokale virksomheder og institutioner, der vil hjælpe unge i trivsel og uddannelse.'
  },
  '/kontakt': {
    title: 'Kontakt - Unges Fremtid',
    description: 'Kontakt Unges Fremtid. Att.: Tom Pedersen, Koglevej 36, 8960 Randers SØ. Tlf: 25 77 86 46.'
  },
  '/nyheder': {
    title: 'Nyheder - Unges Fremtid',
    description: 'Nyheder og pressemeddelelser fra foreningen Unges Fremtid.'
  },
  '/403': {
    title: 'Adgang nægtet - Unges Fremtid',
    description: 'Du har ikke adgang til denne side.'
  }
}

function PageTitleManager() {
  const { pathname } = useLocation()

  useEffect(() => {
    const meta = ROUTE_META[pathname] || {
      title: 'Unges Fremtid',
      description: 'Unges Fremtid er en nonprofitorganisation, der arbejder for at hjælpe udsatte børn og unge.'
    }

    document.title = meta.title

    let metaDesc = document.querySelector('meta[name="description"]')
    if (!metaDesc) {
      metaDesc = document.createElement('meta')
      metaDesc.name = 'description'
      document.head.appendChild(metaDesc)
    }
    metaDesc.content = meta.description
  }, [pathname])

  return null
}

export default function App() {
  return (
    <div className="flex flex-col min-h-screen bg-[#faf9f6] text-neutral-800">
      <ScrollToTop />
      <PageTitleManager />
      <Navbar />

      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/om-unges-fremtid" element={<About />} />
          <Route path="/vores-arbejde" element={<Services />} />
          <Route path="/for-boern-og-unge" element={<Youth />} />
          <Route path="/bliv-involveret" element={<Involved />} />
          <Route path="/nyheder" element={<News />} />
          <Route path="/kontakt" element={<Contact />} />
          <Route path="/403" element={<Forbidden />} />
          <Route path="/404" element={<NotFound />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>

      <FloatingCTA />
      <Footer />
    </div>
  )
}
